import React, { useEffect, useState, useRef } from "react";
import "./FilterCustomPackageComponents.css";
import { Accordion } from "react-bootstrap";
import Cookies from "js-cookie";
import { axiosGet, axiosPut, axiosDelete } from "../../../../utils/apis/api";
import dayjs from "dayjs";
import {
  SpinnerLoading,
  SingleCalendar,
  NotFound,
} from "../../../../components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import hotel from "../../../../assets/images/packages/svg/hotel.svg";
import flight from "../../../../assets/images/packages/svg/flight.svg";
import trasport from "../../../../assets/images/packages/svg/bus.svg";
import service from "../../../../assets/images/packages/svg/services.svg";
import editIcon from "../../../../assets/images/packages/svg/edit-icon.svg";
import deleteIcon from "../../../../assets/images/packages/svg/delete-icon.svg";
import GlobalModal from "../AddModal/GlobalModal";
import { Modal } from "react-bootstrap";
import { useTranslation } from "../../../../contexts/TranslationContext";

const FilterCustomPackageComponents = ({
  url,
  quotationId,
  componentType,
  selectedDates,
  selectedDestination,
  onReturn,
  showAll,
  packageName,
  setSelectedComponent,
  selectedComponent,
  onAlreadyReservedFlight,
  onAlreadyReservedHotel,
  onTboReservedHotel,
  onReservedTransportation,
  setItems,
  onEditService,
  onEditFlight,
  bookWarnings,
  onEditTransportation,
  subLoading
}) => {
  const [isLoading, setIsLoading] = useState(subLoading??false);
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState(null);
  const [matchedItems, setMatchedItems] = useState([]);
  const resultsPerPage = 20;
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const Lang = Cookies.get("preferred_language") || "en";
  const [expandedItems, setExpandedItems] = useState([]);
  const [showToggleForItem, setShowToggleForItem] = useState({});

  const descriptionRefs = useRef([]);

  useEffect(() => {
    const newToggleStates = {};

    descriptionRefs.current.forEach((ref, index) => {
      if (ref) {
        const lineHeight = parseFloat(getComputedStyle(ref).lineHeight || "20");
        const lines = Math.round(ref.scrollHeight / lineHeight);
        newToggleStates[index] = lines > 2;
      }
    });

    setShowToggleForItem(newToggleStates);
  }, [data]);

  const toggleExpand = (index) => {
    setExpandedItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const fetchDetails = async (pageNumber = 1) => {
    try {
      setIsLoading(true);
      var startDate = dayjs(selectedDates.startDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      var endDate = dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss");
      var destinationName = selectedDestination.location;
      var destinationId = selectedDestination.primary_destination_row_id;
      const start = (pageNumber - 1) * resultsPerPage;
      let apiUrl = `${url}/api/method/erpnext.selling.doctype.quotation.quotation.get_quotation_destination_components_by_type?start=${start}&limit=${resultsPerPage}&start_date=${startDate}&end_date=${endDate}&components_type=${componentType}&destination=${destinationName}&name=${quotationId}&destination_row_id=${destinationId}`;
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const response = await axiosGet(apiUrl, {}, headers);
      if (response.status_code === 200) {
        const result = response.result;
        // setCurrentPage(result.pagination.metadata.current_page);
        // setTotalPages(result.pagination.metadata.total_pages);
        setData(result.data);

      } else {
        setData(null);
        toast.error(response.message ?? t("ErrorOccurredWhileFetchingData"), {
          position: "bottom-right",
        });
      }

      setIsLoading(false);
    } catch (error) {
      setData(null);
      setIsLoading(false);
      toast.error(error ?? t("ErrorOccurredWhileFetchingData"), {
        position: "bottom-right",
      });
    }
  };

  const RemoveComponentFromQuot = async (row_id) => {
    setIsLoading(true);

    const payload = {
      quotation_id: packageName,
      row_id: row_id,
    };
    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const response = await axiosPut(
        `${url}/api/method/erpnext.selling.doctype.quotation.quotation.delete_one_componant_from_package`,
        payload,
        headers
      );

      if (response.status === 200) {
        toast.success(t("RemovedSuccessfully"), {
          position: "bottom-right",
        });
        let result = response.data?.result;
        if (result) {
          setItems(result.items ?? []);
        }
        fetchDetails();
      } else {
        toast.error(
          response.message ?? t("ErrorOccurredWhileRemovingReservation"),
          {
            position: "bottom-right",
          }
        );
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error ?? t("ErrorOccurredWhileRemovingReservation"), {
        position: "bottom-right",
      });
      console.error("Error:", error);
    }
    setIsLoading(false);
    setSelectedComponent(null);
  };

  const removeAlreadyReservedComponent = async (
    component_type,
    component_id
  ) => {
    setIsLoading(true);

    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };

      const response = await axiosDelete(
        `${url}/api/method/alltimes.www.api.delete_reservation?quotation_id=${quotationId}&reservation_type=${component_type}&reservation_id=${component_id}`,
        headers
      );

      if (response.status === 200) {
        toast.success(t("RemovedSuccessfully"), {
          position: "bottom-right",
        });
        setIsLoading(false);
        let result = response.data?.result;
        if (result) {
          setItems(result.items ?? []);
        }
        fetchDetails();
      } else {
        toast.error(
          response.message ?? t("ErrorOccurredWhileRemovingReservation"),
          {
            position: "bottom-right",
          }
        );
        setIsLoading(false);
      }
    } catch (error) {
      toast.error(error ?? t("ErrorOccurredWhileRemovingReservation"), {
        position: "bottom-right",
      });
      setIsLoading(false);
      console.error("Error:", error);
    }
    setSelectedComponent(null);
  };

  const updateComponentDatesInQuot = async (row_id, from_date, to_date) => {
    setIsLoading(true);
    let row = {
      date_from: from_date
        ? dayjs(from_date).format("YYYY-MM-DD HH:mm:ss")
        : null,
    };
    if (to_date) {
      row["date_to"] = dayjs(to_date).format("YYYY-MM-DD HH:mm:ss");
    }
    const payload = {
      quotation_id: packageName,
      row_id: row_id,
      row: row,
    };
    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const response = await axiosPut(
        `${url}/api/method/erpnext.selling.doctype.quotation.quotation.update_quotation_component`,
        payload,
        headers
      );

      if (response.status === 200) {
        toast.success(t("UpdatedSuccessfully"), {
          position: "bottom-right",
        });
        let result = response.data?.result;
        if (result) {
          setItems(result.items ?? []);
        }
        fetchDetails();
      } else {
        toast.error(
          response.message ?? t("ErrorOccurredWhileUpdatingReservation"),
          {
            position: "bottom-right",
          }
        );
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error ?? t("ErrorOccurredWhileUpdatingReservation"), {
        position: "bottom-right",
      });
      console.error("Error:", error);
    }
    setIsLoading(false);
    setSelectedComponent(null);
    setFromDate(null);
    setToDate(null);
  };

  useEffect(() => {
    if (showAll) {
      fetchDetails();
    }
  }, [showAll]);

  const handleEditDate = (item) => {
    setFromDate(item.date_from ? new Date(item.date_from) : null);
    setToDate(item.date_to ? new Date(item.date_to) : null);
    // setSelectedComponent(null);
    setIsModalOpen(true);
  };

  useEffect(() => {
    setMatchedItems([]);
    if (data && data.length > 0) {
      const matchedItems = data?.filter((dataItem) =>
        bookWarnings?.some(
          (warning) =>
            warning?.destination_row_id === dataItem?.destination_row_id &&
            warning?.package_component_type ===
              dataItem?.package_component_type &&
            warning?.package_component_id === dataItem?.package_component_id &&
            warning?.reservation_id === dataItem?.reservation_id
        )
      );

      setMatchedItems(matchedItems);
    }
  }, [data, bookWarnings]);

  return (
    <>
      <div className="filter-component-container">
        <div className="filter-component-header">
          <button className="hotel-form-backbtn" onClick={onReturn}>
            {Lang === "ar" ? (
              <>
                {t("BackToPlan")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 23 23"
                  fill="none"
                >
                  <path
                    d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </>
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 23 23"
                  fill="none"
                >
                  <path
                    d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {t("BackToPlan")}
              </>
            )}
          </button>
        </div>

        <div className="filter-component-content">
          {/* <div className="filter-component-content-title">
            Dubai with my family Package
          </div> */}
          <div className="filter-component-content-cities"></div>
          <div className="filter-component-content-date">
            <span></span>
          </div>
          {/* <div className="filter-component-content-amount">
            <span>Total Amount</span> of the package: <label>1456$</label>
          </div> */}
        </div>
      </div>

      {isLoading ? (
        <div className="loading-container">
          <SpinnerLoading />
        </div>
      ) : (
        <Accordion className="filter-component-accordion" defaultActiveKey="0">
          <Accordion.Item
            eventKey="0"
            className="filter-component-accordion-item"
          >
            <Accordion.Header className="filter-component-accordion-header">
              {componentType === "Hotel" ? (
                <img src={hotel} alt="hotel" />
              ) : componentType === "Flight" ? (
                <img src={flight} alt="flight" />
              ) : componentType === "Transportation" ? (
                <img src={trasport} alt="trasport" />
              ) : (
                <img src={service} alt="service" />
              )}

              <div className="filter-title">
                {componentType === "Flight"
                  ? t("Flights")
                  : componentType === "Hotel"
                  ? t("Hotels")
                  : componentType === "All Time Activity"
                  ? t("Activites")
                  : t(componentType)}
              </div>
            </Accordion.Header>
            <Accordion.Body className="filter-component-accordion-body">
              {data && data.length > 0
                ? data.map((item, index) => {
                    const description = item?.description?.trim();
                    const isExpanded = expandedItems.includes(index);

                    return (
                      <div
                        key={index}
                        className={`filter-item-row ${
                          item.package_component_type === "All Time Activity"
                            ? "activity-item-custom-container"
                            : ""
                        }`}
                      >
                        <div className="filter-item-left">
                          {["Hotel Reservation", "Hotel"].includes(
                            item.package_component_type
                          ) && (
                            <div
                              className="hotel-info"
                              style={{ marginTop: "5px" }}
                            >
                              {item.package_component_type ===
                                "Hotel Reservation" &&
                                item.hotel_name && (
                                  <div className="filter-item-name">
                                    <span className="filter-item-name-star">
                                      {matchedItems?.some(
                                        (item1) => item1?.name === item.name
                                      )
                                        ? "⚠︎"
                                        : ""}
                                    </span>
                                    <span>{t("Hotel")}:</span> {item.hotel_name}
                                  </div>
                                )}

                              {item.package_component_type === "Hotel" &&
                                item.name1 && (
                                  <div className="filter-item-name">
                                    {matchedItems?.some(
                                      (item1) => item1?.name === item.name
                                    )
                                      ? "⚠︎"
                                      : ""}
                                    <span>{t("Hotel")}:</span> {item.name1}
                                  </div>
                                )}

                              {(item.date_from || item.date_to) && (
                                <div className="filter-item-dates">
                                  {item.date_from &&
                                    dayjs(item.date_from).format(
                                      "DD MMM YYYY, hh:mm A"
                                    )}
                                  {item.date_from && item.date_to && " - "}
                                  {item.date_to &&
                                    dayjs(item.date_to).format(
                                      "DD MMM YYYY, hh:mm A"
                                    )}
                                </div>
                              )}

                              {item.from_destination_name && (
                                <div className="filter-item-name">
                                  <span>{t("FromDestination")}:</span>{" "}
                                  {item.from_destination_name}
                                </div>
                              )}
                              {item.to_destination_name && (
                                <div className="filter-item-name">
                                  <span>{t("ToDestination")}:</span>{" "}
                                  {item.to_destination_name}
                                </div>
                              )}

                              {item.rate && (
                                <div className="filter-item-name">
                                  <span>{t("Rating")}:</span>{" "}
                                  {[...Array(5)].map((_, index) => (
                                    <span key={index}>
                                      {index < Math.floor(item.rate) ? (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="17"
                                          height="16"
                                          viewBox="0 0 17 16"
                                          fill="none"
                                        >
                                          <path
                                            d="M14.76 5.51739L10.7928 4.94083L9.01939 1.34551C8.97095 1.24708 8.89126 1.16739 8.79283 1.11895C8.54595 0.997076 8.24595 1.09864 8.12251 1.34551L6.34908 4.94083L2.38189 5.51739C2.27251 5.53301 2.17251 5.58458 2.09595 5.6627C2.00339 5.75784 1.95239 5.88583 1.95415 6.01855C1.9559 6.15127 2.01028 6.27786 2.10533 6.37051L4.97564 9.16895L4.29751 13.1205C4.28161 13.2124 4.29178 13.307 4.32688 13.3934C4.36197 13.4798 4.42058 13.5547 4.49606 13.6095C4.57154 13.6644 4.66087 13.6969 4.75392 13.7036C4.84697 13.7102 4.94002 13.6906 5.02251 13.6471L8.57095 11.7815L12.1194 13.6471C12.2163 13.6986 12.3288 13.7158 12.4366 13.6971C12.7084 13.6502 12.8913 13.3924 12.8444 13.1205L12.1663 9.16895L15.0366 6.37051C15.1147 6.29395 15.1663 6.19395 15.1819 6.08458C15.2241 5.81114 15.0334 5.55801 14.76 5.51739Z"
                                            fill="#CF9F47"
                                          />
                                        </svg>
                                      ) : (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="15"
                                          height="15"
                                          viewBox="0 0 15 15"
                                          fill="none"
                                        >
                                          <g clip-path="url(#clip0_754_601)">
                                            <path
                                              d="M13.9598 6.81844C14.1108 6.70593 14.2228 6.54898 14.2802 6.36959C14.3375 6.1902 14.3372 5.99737 14.2794 5.81813C14.2216 5.6389 14.1092 5.48225 13.9578 5.37015C13.8065 5.25805 13.6239 5.19612 13.4356 5.19304L9.77847 5.05488C9.76048 5.05364 9.74325 5.04723 9.72883 5.03641C9.71441 5.0256 9.70342 5.01085 9.6972 4.99393L8.43345 1.5806C8.36996 1.40694 8.25463 1.25699 8.10309 1.15104C7.95155 1.0451 7.77111 0.988281 7.58621 0.988281C7.40131 0.988281 7.22087 1.0451 7.06933 1.15104C6.91779 1.25699 6.80247 1.40694 6.73897 1.5806L5.47929 5.00612C5.47307 5.02304 5.46208 5.03779 5.44766 5.0486C5.43324 5.05942 5.416 5.06583 5.39802 5.06707L1.74088 5.20523C1.55258 5.20831 1.36996 5.27024 1.21864 5.38234C1.06731 5.49444 0.954862 5.65109 0.897059 5.83032C0.839256 6.00956 0.838996 6.20239 0.896317 6.38178C0.953638 6.56117 1.06566 6.71812 1.21669 6.83063L4.08551 9.08587C4.09987 9.09717 4.1106 9.11243 4.11638 9.12976C4.12216 9.14709 4.12273 9.16574 4.11802 9.18339L3.13059 12.6821C3.07943 12.8602 3.08438 13.0498 3.14479 13.2251C3.2052 13.4003 3.31813 13.5527 3.46821 13.6615C3.61829 13.7703 3.79824 13.8302 3.98358 13.8331C4.16892 13.836 4.35065 13.7817 4.50405 13.6776L7.53542 11.6459C7.55035 11.6356 7.56807 11.63 7.58621 11.63C7.60436 11.63 7.62207 11.6356 7.63701 11.6459L10.6684 13.6776C10.8197 13.7852 11.0008 13.8431 11.1865 13.8431C11.3722 13.8431 11.5532 13.7852 11.7046 13.6776C11.8547 13.5699 11.9677 13.4182 12.0281 13.2436C12.0885 13.0689 12.0933 12.8799 12.0418 12.7024L11.0463 9.19152C11.041 9.17389 11.0413 9.15507 11.0471 9.13762C11.0529 9.12016 11.064 9.10493 11.0788 9.094L13.9598 6.81844Z"
                                              fill="none"
                                              stroke="#CF9F47"
                                              stroke-width="1"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_754_601">
                                              <rect
                                                width="14.6286"
                                                height="14.6286"
                                                fill="white"
                                                transform="translate(0.143555)"
                                              />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      )}
                                    </span>
                                  ))}
                                </div>
                              )}
                              {item.check_in && (
                                <div className="filter-item-name">
                                  <span>{t("CheckInDate")}:</span>{" "}
                                  {dayjs(item.check_in).format(
                                    "DD MMM YYYY, hh:mm A"
                                  )}
                                </div>
                              )}
                              {item.check_out && (
                                <div className="filter-item-name">
                                  <span>{t("CheckOutDate")}:</span>{" "}
                                  {dayjs(item.check_out).format(
                                    "DD MMM YYYY, hh:mm A"
                                  )}
                                </div>
                              )}
                              {item.description && (
                                <div className="inclusion-description">
                                  <p>{item.description}</p>
                                </div>
                              )}
                            </div>
                          )}

                          {["Flight Reservation", "Flight"].includes(
                            item.package_component_type
                          ) && (
                            <div
                              className="flight-info"
                              style={{ marginTop: "5px" }}
                            >
                              <div className="filter-item-name">
                                <span className="filter-item-name-star">
                                  {matchedItems?.some(
                                    (item1) => item1?.name === item.name
                                  )
                                    ? "⚠︎"
                                    : ""}
                                </span>
                                {t("FlightId")}: {item.package_component_id}
                              </div>
                              {(item.date_from || item.date_to) && (
                                <div className="filter-item-dates">
                                  {item.date_from &&
                                    dayjs(item.date_from).format(
                                      "DD MMM YYYY, hh:mm A"
                                    )}
                                  {item.date_from && item.date_to && " - "}
                                  {item.date_to &&
                                    dayjs(item.date_to).format(
                                      "DD MMM YYYY, hh:mm A"
                                    )}
                                </div>
                              )}

                              {item.from_destination_name && (
                                <div className="filter-item-name">
                                  <span>{t("FromDestination")}:</span>{" "}
                                  {item.from_destination_name}
                                </div>
                              )}
                              {item.to_destination_name && (
                                <div className="filter-item-name">
                                  <span>{t("ToDestination")}:</span>{" "}
                                  {item.to_destination_name}
                                </div>
                              )}
                              {item.destination_airline_name && (
                                <div className="filter-item-name">
                                  <span>{t("DestinationAirline")}:</span>{" "}
                                  {item.destination_airline_name}
                                </div>
                              )}
                              {item.destination_airport_name && (
                                <div className="filter-item-name">
                                  <span>{t("DestinationAirport")}:</span>{" "}
                                  {item.destination_airport_name}
                                </div>
                              )}
                              {item.departure_airport_name && (
                                <div className="filter-item-name">
                                  <span>{t("DepartureAirport")}:</span>{" "}
                                  {item.departure_airport_name}
                                </div>
                              )}
                              {item.arrival_airport_name && (
                                <div className="filter-item-name">
                                  <span>{t("ArrivalAirport")}:</span>{" "}
                                  {item.arrival_airport_name}
                                </div>
                              )}
                              {item.airline && (
                                <div className="filter-item-name">
                                  <span>{t("Airline")}:</span> {item.airline}
                                </div>
                              )}
                              {item.departure_date && (
                                <div className="filter-item-name">
                                  <span>{t("DepartureDate")}:</span>{" "}
                                  {dayjs(item.departure_date).format(
                                    "DD MMM YYYY, hh:mm A"
                                  )}
                                </div>
                              )}
                              {item.return_date && (
                                <div className="filter-item-name">
                                  <span>{t("ReturnDate")}:</span>{" "}
                                  {dayjs(item.return_date).format(
                                    "DD MMM YYYY, hh:mm A"
                                  )}
                                </div>
                              )}
                              {item.description && (
                                <div className="inclusion-description">
                                  <p>{item.description}</p>
                                </div>
                              )}
                            </div>
                          )}

                          {item.package_component_type === "Transportation" && (
                            <div
                              className="hotel-info"
                              style={{ marginTop: "5px" }}
                            >
                              {item.name1 && (
                                <div className="filter-item-name">
                                  <span className="filter-item-name-star">
                                    {matchedItems?.some(
                                      (item1) => item1?.name === item.name
                                    )
                                      ? "⚠︎"
                                      : ""}
                                  </span>
                                  <span>{t("TransportName")}:</span>{" "}
                                  {item.name1}
                                </div>
                              )}

                              {(item.date_from || item.date_to) && (
                                <div className="filter-item-dates">
                                  {item.date_from &&
                                    dayjs(item.date_from).format(
                                      "DD MMM YYYY, hh:mm A"
                                    )}
                                  {item.date_from && item.date_to && " - "}
                                  {item.date_to &&
                                    dayjs(item.date_to).format(
                                      "DD MMM YYYY, hh:mm A"
                                    )}
                                </div>
                              )}

                              {item.from_destination_name && (
                                <div className="filter-item-name">
                                  <span>{t("FromDestination")}:</span>{" "}
                                  {item.from_destination_name}
                                </div>
                              )}
                              {item.to_destination_name && (
                                <div className="filter-item-name">
                                  <span>{t("ToDestination")}:</span>{" "}
                                  {item.to_destination_name}
                                </div>
                              )}
                              {item.capacity > 0 && (
                                <div className="filter-item-name">
                                  <span>{t("Capacity")}:</span> {item.capacity}
                                </div>
                              )}
                              {item.type && (
                                <div className="filter-item-name">
                                  <span>{t("TransportType")}:</span>{" "}
                                  {t(item.type)}
                                </div>
                              )}

                              {item.description && (
                                <div className="inclusion-description">
                                  <p>{item.description}</p>
                                </div>
                              )}
                            </div>
                          )}

                          {item.package_component_type === "Service" && (
                            <div
                              className="hotel-info"
                              style={{ marginTop: "5px" }}
                            >
                              {item.name1 && (
                                <div className="filter-item-name">
                                  <span className="filter-item-name-star">
                                    {matchedItems?.some(
                                      (item1) => item1?.name === item.name
                                    )
                                      ? "⚠︎"
                                      : ""}
                                  </span>
                                  <span>{item.name1}</span>
                                </div>
                              )}
                              {(item.date_from || item.date_to) && (
                                <div className="filter-item-dates">
                                  {item.date_from &&
                                    dayjs(item.date_from).format(
                                      "DD MMM YYYY, hh:mm A"
                                    )}
                                  {item.date_from && item.date_to && " - "}
                                  {item.date_to &&
                                    dayjs(item.date_to).format(
                                      "DD MMM YYYY, hh:mm A"
                                    )}
                                </div>
                              )}

                              {item.details && (
                                <div className="filter-item-name">
                                  <span>{t("ServiceDetails")}:</span>{" "}
                                  {item.details}
                                </div>
                              )}
                              {item.description && (
                                <div className="inclusion-description">
                                  <p>{item.description}</p>
                                </div>
                              )}
                            </div>
                          )}

                          {item.package_component_type ===
                            "All Time Activity" && (
                            <div
                              className="hotel-info"
                              style={{ marginTop: "5px" }}
                            >
                              {item.image && (
                                <div className="activity-img-container">
                                  <img
                                    src={url + item.image}
                                    alt=""
                                    className="activity-img"
                                  ></img>
                                </div>
                              )}
                              <div className="activity-info">
                                {item.name1 && (
                                  <div className="filter-item-name">
                                    <span className="filter-item-name-star">
                                      {matchedItems?.some(
                                        (item1) => item1?.name === item.name
                                      )
                                        ? "⚠︎"
                                        : ""}
                                    </span>
                                    <span>{t("ActivityName")}:</span>{" "}
                                    {item.name1}
                                  </div>
                                )}

                                {(item.date_from || item.date_to) && (
                                  <div className="filter-item-dates">
                                    {item.date_from &&
                                      dayjs(item.date_from).format(
                                        "DD MMM YYYY, hh:mm A"
                                      )}
                                    {item.date_from && item.date_to && " - "}
                                    {item.date_to &&
                                      dayjs(item.date_to).format(
                                        "DD MMM YYYY, hh:mm A"
                                      )}
                                  </div>
                                )}

                                {item.from_destination && (
                                  <div className="filter-item-name">
                                    <span>{t("FromDestination")}:</span>{" "}
                                    {item.from_destination_name}
                                  </div>
                                )}
                                {item.to_destination && (
                                  <div className="filter-item-name">
                                    <span>{t("ToDestination")}:</span>{" "}
                                    {item.to_destination_name}
                                  </div>
                                )}

                                {description && (
                                  <div className="inclusion-description filter-item-name">
                                    <p
                                      ref={(el) =>
                                        (descriptionRefs.current[index] = el)
                                      }
                                      className={`description-text ${
                                        isExpanded ? "expanded" : ""
                                      }`}
                                    >
                                      <span>{t("Description")}:</span>{" "}
                                      {description}
                                    </p>

                                    {showToggleForItem[index] && (
                                      <span
                                        className="read-more-toggle"
                                        onClick={() => toggleExpand(index)}
                                      >
                                        {isExpanded
                                          ? t("ReadLess")
                                          : t("ReadMore")}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                        </div>

                        <div className="filter-item-actions">
                          {
                            <div
                              className="edit-div"
                              onClick={() => {
                                if (componentType === "Flight") {
                                  if (item.already_reserved === 1) {
                                    setSelectedComponent(item);
                                    onAlreadyReservedFlight();
                                  } else {
                                    setSelectedComponent(item);
                                    onEditFlight?.(item);
                                    // onReturn();
                                  }
                                } else if (componentType === "Hotel") {
                                  if (item.already_reserved === 1) {
                                    setSelectedComponent(item);
                                    onAlreadyReservedHotel();
                                  } else {
                                    setSelectedComponent(item);
                                    onTboReservedHotel(item);
                                  }
                                } else if (componentType === "Transportation") {
                                  setSelectedComponent(item);
                                  onEditTransportation?.(item);
                                  onReservedTransportation();
                                } else if (
                                  componentType === "All Time Activity"
                                ) {
                                  setSelectedComponent(item);
                                  handleEditDate(item);
                                } else if (componentType === "Service") {
                                  setSelectedComponent(item);
                                  onEditService?.(item);
                                }
                              }}
                            >
                            
                                <img
                                  src={editIcon}
                                  className="edit-icon"
                                  alt=""
                                />
                            

                              <span className="action-text">{t("Edit")}</span>
                            </div>
                          }

                          <span
                            className="action-text delete-text"
                            onClick={() => {
                              setSelectedComponent(item);
                              setShowDelete(true);
                            }}
                          >
                            <img src={deleteIcon} alt=""></img>
                          </span>
                        </div>
                      </div>
                    );
                  })
                : !isLoading &&
                  data &&
                  data.length === 0 && (
                    <NotFound
                      errorCode={"204"}
                      errorMessage={t("NoData")}
                      description={
                        componentType === "Flight"
                          ? t("NoFlightsReserved")
                          : componentType === "Hotel"
                          ? t("NoHotelsReserved")
                          : componentType === "Transportation"
                          ? t("NoTransportationReserved")
                          : componentType === "All Time Activity"
                          ? t("NoActivitesReserved")
                          : t("NoServicesReserved")
                      }
                    ></NotFound>
                  )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}
      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
      <GlobalModal
        title={`${
          componentType === "All Time Activity"
            ? t("RemoveActivity")
            : componentType === "Hotel"
            ? t("RemoveHotel")
            : componentType === "Flight"
            ? t("RemoveFlight")
            : componentType === "Transportation"
            ? t("RemoveTransport")
            : t("RemoveService")
        }`}
        subtitle={t("ConfirmationRemove")}
        globalModal={showDelete}
        onClick={() => {
          setShowDelete(false);
          //should check this
          if (selectedComponent!==null && selectedComponent.package_component_id
            && selectedComponent.already_reserved === 1
          ) {
            removeAlreadyReservedComponent(
              selectedComponent.package_component_type,
              selectedComponent.package_component_id
            );
          } else {
            RemoveComponentFromQuot(selectedComponent.name);
          }
        }}
        onClose={() => {
          setSelectedComponent(null);
          setShowDelete(false);
        }}
      ></GlobalModal>
      <Modal
        show={isModalOpen}
        onHide={() => {
          setIsModalOpen(false);
          setSelectedComponent(null);
        }}
        centered
        className={`${Lang === "ar" ? "rtl" : "ltr"}`}
      >
        <Modal.Header>
          <Modal.Title>
            {componentType === "All Time Activity"
              ? t("EditActivityDate")
              : componentType === "Transportation"
              ? t("EditTransportDates")
              : t("EditServiceDates")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label style={{ display: "block", marginBottom: "8px" }}>
            {componentType === "Service" || componentType === "Transportation"
              ? t("FromDate")
              : t("Date")}
          </label>
          <SingleCalendar
            value={fromDate}
            onChange={(e) =>
              setFromDate(e.value != null ? new Date(e.value) : null)
            }
            min={new Date(selectedDates.startDate)}
            max={
              toDate
                ? new Date(
                    Math.min(
                      new Date(toDate).getTime(),
                      new Date(selectedDates.endDate).getTime()
                    )
                  )
                : new Date(selectedDates.endDate)
            }
          />

          {(componentType === "Service" ||
            componentType === "Transportation") && (
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                marginTop: "20px",
              }}
            >
              {t("ToDate")}:
            </label>
          )}
          {(componentType === "Service" ||
            componentType === "Transportation") && (
            <SingleCalendar
              value={toDate}
              onChange={(e) =>
                setToDate(e.value != null ? new Date(e.value) : null)
              }
              min={
                fromDate
                  ? new Date(
                      Math.max(
                        new Date(fromDate).getTime(),
                        new Date(selectedDates.startDate).getTime()
                      )
                    )
                  : new Date(selectedDates.startDate)
              }
              max={new Date(selectedDates.endDate)}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="save-btn"
            onClick={() => {
              if (
                (componentType === "All Time Activity" && fromDate) ||
                (componentType !== "All Time Activity" && fromDate && toDate)
              ) {
                setIsModalOpen(false);
                updateComponentDatesInQuot(selectedComponent.name, fromDate, toDate);
              }
            }}
          >
            {t("Save")}
          </button>
          <button
            className=" save-btn cancel-btn"
            onClick={() => {
              setIsModalOpen(false);
              setSelectedComponent(null);
            }}
          >
            {t("Cancel")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FilterCustomPackageComponents;
